export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11968.885d610c.jpg";